import React from "react";
import { useAuthStore } from "../../store/authStore";
import { Sidebar } from "primereact/sidebar";
import useSize from "../ui/useSize";
import { useSidebarStore } from "../../store/sidebarStore";
import { Ripple } from "primereact/ripple";
import logo from '../../assets/musterlogoyeni.png';
export default function SidebarCom() {
  const { claims } = useAuthStore();
  const windowsize = useSize();
  const { menuOpen, setMenuOpen } = useSidebarStore();

  const adminItems = []; // Admin öğeleri için ayrı bir liste
  const generalItems = [ // Genel öğeler
    {
      label: "Gösterge Paneli",
      icon: "pi pi-home",
      command: () => {
        setMenuOpen(false);
        window.location.href = "/admin/dashboard";
      },
    }, {
      label: "Sevke Hazır Ürünler",
      icon: "pi pi-box",
      command: () => {
        setMenuOpen(false);
        window.location.href = "/admin/dispatch";
      },
    },
    {
      label: "Depo Ürünleri",
      icon: "pi pi-warehouse",
      command: () => {
        setMenuOpen(false);
        window.location.href = "/admin/warehouse";
      },
    },
    {
      label: "Talimatlar",
      icon: "pi pi-file-check",
      command: () => {
        setMenuOpen(false);
        window.location.href = "/admin/checklist";
      },
    }, {
      label: "İletişim",
      icon: "pi pi-map-marker",
      command: () => {
        setMenuOpen(false);
        window.location.href = "/admin/contact";
      },
    },
  ];

  // Admin öğelerini dinamik olarak ekleme
  if (claims?.includes("CreateCurrentsUserCommand")) {
    adminItems.push({
      label: "Kullanıcı Ayarları",
      icon: "pi pi-cog",
      command: () => {
        setMenuOpen(false);
        window.location.href = "/admin/users";
      },
    });
  }
  if (claims?.includes("GetCurrentQuery")) {
    adminItems.push({
      label: "Firma Yönetimi",
      icon: "pi pi-users",
      command: () => {
        setMenuOpen(false);
        window.location.href = "/admin/companies";
      },
    }); 
    adminItems.push({
      label: "Tüm Talimatlar",
      icon: "pi pi-file-check",
      command: () => {
        setMenuOpen(false);
        window.location.href = "/admin/syschecklist";
      },
    });  
    adminItems.push({
      label: "Tüm Hazır Ürünler",
      icon: "pi pi-truck",
      command: () => {
        setMenuOpen(false);
        window.location.href = "/admin/sysdispatch";
      },
    });  
    adminItems.push({
      label: "Tüm Depo Ürünleri",
      icon: "pi pi-warehouse",
      command: () => {
        setMenuOpen(false);
        window.location.href = "/admin/syswarehouse";
      },
    });  
  }

  return windowsize[0] >= 1000 ? (
    <div className="p-0 m-0 h-screen">{sideMenu(generalItems, adminItems)}</div>
  ) : (
    <div className="p-0 m-0 h-screen">
      <Sidebar
        content={sideMenu(generalItems, adminItems)}
        closeIcon={false}
        visible={menuOpen}
        onHide={() => setMenuOpen(false)}
      />
    </div>
  );
}

function sideMenu(generalItems, adminItems) {
  return (
    <div className="min-w-max shadow-3">
      <div
        id="app-sidebar-2"
        className="surface-section w-12 h-screen block flex-shrink-0 absolute lg:static left-0 top-0 z-1 border-right-1 surface-border select-none"
      >
        <div className="flex flex-column h-full">
          <div className="flex align-items-center justify-content-center pt-3  flex-shrink-0 ">
            <span className="inline-flex align-items-center gap-2">
              <span className="font-semibold text-xl text-primary">
              <img src={logo} alt="BERP Logo" className="w-12rem " />
              </span>
            </span>
          </div>
          <hr className="mx-3 text-center border-top-1 border-none surface-border shadow-2" />
          <div className="overflow-y-auto">
            <ul className="list-none px-3 m-0">
              {/* Genel öğeleri render et */}
              {generalItems.map((item, index) => (
                <li key={index} onClick={item.command}>
                  <div className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                    <i className={`${item.icon} mr-2`}></i>
                    <span className="font-medium">{item.label}</span>
                    <Ripple />
                  </div>
                </li>
              ))}
              {/* Admin başlığı ve öğeleri */}
              {adminItems.length > 0 && (
                <>
                  <div className="font-bold text-lg text-primary mb-2">Admin</div>
                  {adminItems.map((item, index) => (
                    <li key={index} onClick={item.command}>
                      <div className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                        <i className={`${item.icon} mr-2`}></i>
                        <span className="font-medium">{item.label}</span>
                        <Ripple />
                      </div>
                    </li>
                  ))}
                </>
              )}
            </ul>
          </div>
          <div className="mt-auto">
            <hr className="mx-3 text-center border-top-1 border-none surface-border" />
            <div className="text-center text-sm pb-2">
              <span>Etkili Yazılım</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
